import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-password-meter',
  styleUrls: ['./password-meter.component.scss'],
  templateUrl: './password-meter.component.html',
})
export class PasswordMeterComponent implements OnChanges {
  @Input() public password: string;
  @Input() public color: string;

  public hasEightChars: boolean;
  public hasUppercaseLetters: boolean;
  public hasLowercaseLetters: boolean;
  public hasDigits: boolean;

  public ngOnChanges(): void {
    this.hasEightChars = this.password.length >= 8;
    this.hasUppercaseLetters = this.password.toLocaleLowerCase() !== this.password;
    this.hasLowercaseLetters = this.password.toLocaleUpperCase() !== this.password;
    this.hasDigits = !!/\d/.exec(this.password);
  }
}
